import React, { Component } from 'react'
import { withRouter } from 'react-router-dom'
import CacheKeys from '../../../cache/CacheKeys'
import CacheManager from '../../../cache/CacheManager'
import RepaymentPage2UI from './RepaymentPage2UI.js'
import RestApiUtils from '../../../apiclient/moebli/RestApiUtils.js'

class RepaymentPage2SF extends Component {
  constructor(props) {
    super(props)
    this.state = {
      errorList: null,
      loan: null,
      repaymentList: null,
      chargeAmountsList:null,
      totals: null,
      downloadSubmitted: false,
      collectionSubmitted: false,
      loanInterestMode: false,
    }
  }

  render() {
    return (
      <RepaymentPage2UI
        context={this.props.context}
        errorList={this.state.errorList}
        loan={this.state.loan}
        account={this.state.account}
        repaymentList={this.state.repaymentList}
        chargeAmountsList={this.state.chargeAmountsList}
        totals={this.state.totals}
        onRefreshClick={this.onRefreshClick}
        //
        onDownloadClick={this.onDownloadClick}
        downloadSubmitted={this.state.downloadSubmitted}
        //
        collectionSubmitted={this.state.collectionSubmitted}
        onCollectionSubmitClick={() => { this.setState({ collectionSubmitted: true }) }}
        onCollectionCancelClick={() => { this.setState({ collectionSubmitted: false }) }}
        //loan interest certificate download
        onLoanInterestClick={() => { this.setState({ loanInterestMode: true }) }}
        loanInterestMode={this.state.loanInterestMode}
        onLoanInterestCancel={() => { this.setState({ loanInterestMode: false }) }}
        //delete disbursement
        onDeleteClick={this.onDeleteClick}
        onDeleteClickCallback={this.onDeleteClickCallback}
        deleteSubmitted={this.state.deleteSubmitted}
      />
    )
  }

  componentDidMount() {
    let context = this.props.context
    this.getLoan(context)
    this.getRepayments(context)
  }

  getRepayments(context) {
    let cacheManager = new CacheManager({
      resource: `/api/su/loans/${this.props.match.params.loanId}/repayments`,
      cacheKey: CacheKeys.Repayments(this.props.match.params.loanId),
      callback: this.getRepaymentsCallback,
      ttlInSecs: 600
    })
    cacheManager.getObject2(context)
  }

  getRepaymentsCallback = (response) => {
    this.setState({ errorList: response.errorList, totals: response, repaymentList: response.repaymentList,chargeAmountsList:response.repaymentList.chargesAmountsList })
  }

  getLoan(context) {
    let cacheManager = new CacheManager({
      resource: `/api/su/loans/${this.props.match.params.loanId}`,
      cacheKey: CacheKeys.Loan(this.props.match.params.loanId),
      callback: this.getLoanCallback,
      ttlInSecs: 600
    })
    cacheManager.getObject2(context)
  }

  getLoanCallback = (response) => {
    let context = this.props.context
    this.setState({ errorList: response.errorList, loan: response.loan })
    this.getAccount(context, response.loan.accountId)
  }

  getAccount(context, accountId) {
    let cacheManager = new CacheManager({
      resource: `/api/su/accounts/${accountId}`,
      cacheKey: CacheKeys.Account(accountId),
      callback: this.getAccountCallback,
      ttlInSecs: 600
    })
    cacheManager.getObject2(context)
  }

  getAccountCallback = (response) => {
    this.setState({ account: response.account })
  }

  onDownloadClick = () => {
    let loan = this.state.loan
    this.setState({
      downloadErrorList: null,
      downloadSubmitted: true
    })
    RestApiUtils.get(this.props.context,
      `/api/su/loans/${loan.loanId}/repayments/excel/fileDownloadSignedUrl`,
      this.onDownloadClickCallback, null, null
    )
  }

  onDownloadClickCallback = (response) => {
    this.setState({
      downloadErrorList: response.errorList,
      downloadSubmitted: false
    })

    if (response.errorList.length === 0) {
      const link = document.createElement('a')
      link.href = response.signedUrl.signedUrl
      document.body.appendChild(link)
      link.click()
      document.body.removeChild(link)
    }
  }

  onDeleteClick = (event) => {
    if (this.state.deleteSubmitted)
      return

    this.setState({ deleteSubmitted: true })
    RestApiUtils.delete(this.props.context,
      `/api/su/loans/${this.props.match.params.loanId}/disbursements`,
      this.onDeleteClickCallback, {}
    )
  }

  onDeleteClickCallback = (response) => {
    this.setState({ deleteSubmitted: false })

    if (response.errorList.length === 0) {
      this.onRefreshClick()
    }
  }

  onRefreshClick = (noBusy) => {
    let loan = this.state.loan
    let context = this.props.context
    CacheManager.removeObject(CacheKeys.Repayments(loan.loanId))
    if (noBusy === 'noBusy') {
      this.getRepayments(context)
    }
    else {
      CacheManager.removeObject(CacheKeys.Loan(loan.loanId))
      this.setState({
        loan: null,
        repaymentList: null,
        errorList: null,
      })
      this.getLoan(context)
      this.getRepayments(context)
    }
  }
}

export default withRouter(RepaymentPage2SF)
